import { render, staticRenderFns } from "./iconGroup.vue?vue&type=template&id=486215b9"
import script from "./iconGroup.vue?vue&type=script&lang=js"
export * from "./iconGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports